import type { ProductPostage } from "@baluu/ui/lib/checkout";

/** What the product overlay needs from the product's page data. */
/** The product as the page data has it: what the basket line reads, and
 *  the rest `CheckoutProduct` reads for itself. */
export type PageProduct = {
  _id?: string;
  slug?: string;
  price?: number;
  currency?: string;
  cover?: string;
  images?: unknown[];
  gifting?: { giftingFee?: number } | null;
  discount?: unknown;
  [key: string]: unknown;
};

export type ProductPage = { product: PageProduct; postages: ProductPostage[] };

/** `GET /widget/pages/product/:slug`, following a renamed product's 301
 *  (the API answers it with the new slug in the body) once. */
export async function fetchProductPage(base: string, slug: string, hops = 1): Promise<ProductPage | null> {
  const response = await fetch(`${base}/widget/pages/product/${encodeURIComponent(slug)}`);
  if (response.status === 301 && hops > 0) {
    const moved = await response.json().catch(() => null);
    return typeof moved?.slug === "string" ? fetchProductPage(base, moved.slug, hops - 1) : null;
  }
  if (!response.ok) return null;
  const body = await response.json().catch(() => null);
  return body?.product ? { product: body.product, postages: Array.isArray(body.postages) ? body.postages : [] } : null;
}
